<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="700px"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Trigger JEA
        </v-card-title>
        <v-progress-linear
          v-if="isLoading"
          :indeterminate="true"
          class="ma-0"
        />

        <v-card-text>
          <p>Are you sure you want to trigger the JEA?</p>

          <v-container
            grid-list-md
            class="pa-0"
          >
            <v-layout
              wrap
              class="form-group"
            >
              <v-flex xs12>
                <h6 class="subheading">
                  JEA Trigger
                </h6>
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  v-model="formData.document_type"
                  label="Document Type"
                  :disabled="true"
                  @change="$v.formData.document_type.$touch()"
                  @blur="$v.formData.document_type.$touch()"
                />
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  v-model="formData.user_id_filter"
                  label="User ID Filter (Comma Separated)"
                  :disabled="triggerAllJea"
                  @change="$v.formData.user_id_filter.$touch()"
                  @blur="$v.formData.user_id_filter.$touch()"
                />
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-checkbox
                  v-model="triggerAllJea"
                  label="I really want to trigger the JEA for all Users at once!"
                  item-key="id"
                  item-text="name"
                  item-value="id"
                  @change="formData.user_id_filter = ''"
                  @input="$v.triggerAllJea.$touch()"
                  @blur="$v.triggerAllJea.$touch()"
                />
              </v-flex>
            </v-layout>
          </v-container>

          <v-alert
            v-for="e in error"
            :key="e.path"
            :value="error"
            type="error"
            color="error"
          >
            {{ e.message }}
          </v-alert>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            cancel
          </v-btn>
          <v-btn
            color="warning"
            flat
            :disabled="!isTriggerable()"
            @click="onSubmit"
          >
            <v-icon>not_started</v-icon>
            Start
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'TriggerJeaDialog',
  components: {
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      isLoading: false,
      error: null,
      triggerAllJea: false,
      formData: {
        document_type: '',
        user_id_filter: '',
      },
    };
  },
  validations() {
    return {
      formData: {
        document_type: { required },
        user_id_filter: { required },
      },
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  mounted() {
    this.formData = {
      document_type: 'jea-2020',
      user_id_filter: '',
    };
  },
  methods: {
    onSubmit() {
      this.isLoading = true;

      this.$store
        .dispatch('callJea2020Trigger', {
          document_type: this.formData.document_type,
          user_id_filter: this.formData.user_id_filter
            .split(',')
            .map(item => item.trim())
            .filter(item => item !== ''),
        })
        .then((data) => {
          this.$emit('success', data);
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    isTriggerable() {
      return this.triggerAllJea || (!this.triggerAllJea && this.formData.user_id_filter !== '');
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/jea/TriggerJeaDialog.vue